var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcesstitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.69 15.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #0072cb;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m4.14,9.03c.85,0,1.69,0,2.54,0,.95,0,1.59.65,1.6,1.6,0,1.18,0,2.36,0,3.54,0,.9-.58,1.55-1.47,1.59-1.81.08-3.62.08-5.43,0-.73-.04-1.35-.69-1.36-1.43-.02-1.29-.02-2.57,0-3.86.01-.79.68-1.42,1.49-1.44.03,0,.06,0,.1,0,.85,0,1.69,0,2.54,0Zm-.03,5.72c.8,0,1.61,0,2.41,0,.51,0,.7-.19.7-.7,0-1.09,0-2.19,0-3.28,0-.53-.18-.72-.71-.72-1.59,0-3.17,0-4.76,0-.51,0-.7.19-.7.7,0,1.09,0,2.19,0,3.28,0,.55.18.72.74.72.77,0,1.54,0,2.32,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m4.14,0c.85,0,1.69,0,2.54,0,.95,0,1.59.65,1.6,1.6,0,1.18,0,2.36,0,3.54,0,.9-.58,1.55-1.47,1.59-1.81.08-3.62.08-5.43,0-.73-.04-1.35-.69-1.36-1.43-.02-1.29-.02-2.57,0-3.86C.03.65.7.03,1.5,0c.03,0,.06,0,.1,0,.85,0,1.69,0,2.54,0Zm-.03,5.72c.8,0,1.61,0,2.41,0,.51,0,.7-.19.7-.7,0-1.09,0-2.19,0-3.28,0-.53-.18-.72-.71-.72-1.59,0-3.17,0-4.76,0-.51,0-.7.19-.7.7,0,1.09,0,2.19,0,3.28,0,.55.18.72.74.72.77,0,1.54,0,2.32,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.49,12.92c.21.23.39.43.58.64.25.28.27.54.06.77-.21.23-.48.24-.77-.01-.55-.5-1.08-1.01-1.6-1.53-.25-.25-.25-.48-.02-.74.51-.58,1.09-1.09,1.66-1.61.23-.21.54-.18.73.02.19.21.19.48-.03.73-.2.22-.42.42-.69.68.72,0,1.37,0,2.02,0,.13,0,.19-.09.19-.21,0-.16,0-.32,0-.48,0-2.28,0-4.57,0-6.85q0-.47-.45-.47c-.92,0-1.84,0-2.76,0-.1,0-.19,0-.29,0-.33-.04-.55-.26-.54-.54,0-.28.24-.5.56-.51,1.19,0,2.38-.02,3.57,0,.56,0,.96.44.96,1.01,0,2.7,0,5.4,0,8.1,0,.6-.43,1-1.06,1.01-.71.01-1.41,0-2.13,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesstitle);
export default __webpack_public_path__ + "static/media/Process title.d95903a27aa92942bbdc60eb9e37fb22.svg";
export { ForwardRef as ReactComponent };